import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const CheckedIcon = (param)=>{
    let { width = 20, height = 20 } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: "".concat(width),
        height: "".concat(height),
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.57339 12C6.38862 11.9994 6.21237 11.9222 6.08673 11.7867L2.84673 8.34002C2.59452 8.07125 2.60795 7.64891 2.87673 7.39669C3.1455 7.14448 3.56785 7.15791 3.82006 7.42669L6.56673 10.3534L12.1734 4.22003C12.4039 3.93295 12.8235 3.88711 13.1106 4.11765C13.3977 4.34819 13.4435 4.7678 13.213 5.05488C13.1965 5.0754 13.1788 5.09493 13.1601 5.11336L7.06672 11.78C6.94225 11.918 6.76585 11.9977 6.58006 12H6.57339Z",
                fill: "currentColor"
            })
        ]
    });
};
